/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_StoneInputs */

const cs_enum_stone = /** @type {(inputs: Enum_StoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kámen`)
};

const en_enum_stone = /** @type {(inputs: Enum_StoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stone`)
};

/**
* | output |
* | --- |
* | "Stone" |
*
* @param {Enum_StoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_stone = /** @type {((inputs?: Enum_StoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_StoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_stone(inputs)
	return cs_enum_stone(inputs)
});